export class WsRequest {
  // TODO: temporary fix. (websocket emit OPEN event after message sent).
  isSent = false;
  retryOnlyOnError = false;
  constructor(private data: unknown, retryOnlyOnError?: boolean) {
    this.retryOnlyOnError = retryOnlyOnError || false;
  }

  clone(): WsRequest {
    return new WsRequest(this.data);
  }

  public get message(): unknown {
    return this.data;
  }
}
